import { apiRequest } from "./apiRequest";

export interface ScrapingProgressData {
  overallStatus: "idle" | "in_progress" | "completed" | "failed";
  overallProgress: number;
  totalWebsites: number;
  participatingWebsitesCount?: number;
  inProgressCount: number;
  completedCount: number;
  failedCount: number;
  totalUrls: number;
  processedUrls: number;
  estimatedTimeRemaining: string | null;
  currentOperation: string;
  websites: Array<{
    id: number;
    name: string;
    url: string;
    scrapingStatus: string;
    scrapingProgress: number;
    currentOperation: string | null;
    totalUrls: number;
    processedUrls: number;
    itemsScraped: number;
    errorCount: number;
    successRate: number;
    timeDuration: string | null;
    scrapedAt: string | null;
  }>;
}

export const getScrapingProgress = async (): Promise<ScrapingProgressData> => {
  return await apiRequest<ScrapingProgressData>("get", "/scraping/progress", {
    params: { _t: Date.now() },
  });
};

export const resetScrapingStatus = async (): Promise<void> => {
  await apiRequest("post", "/scraping/reset");
};
